import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { LeadPage, LeadProvider, UploadPage } from "./leads";

import {
	CreateProjectBudgetPage,
	CreateProjectPage,
	MyProjectsListPage,
	ProjectBudgetPage,
	ProjectBudgetProvider,
	ProjectDashboardPage,
	ProjectProvider,
	ProjectsBudgetTable,
	ProjectsTable,
} from "./projects";
import { UserProvider, UsersListPage } from "./users";

import { DashboardPage } from "./dashboard";
import { AccountProductsTable, BundlePage, LibraryPage, ProductPage } from "./products";
import { FormAdminPage } from "./forms";
import { TagAdminPage } from "./tags";
import { PromoPage } from "./promos";
import { PipelineFunnelPage, ConversionReportPage, SalesCyclePage } from "./reports";

import "./sass/app.scss";

export const App = () => {
	return (
		<UserProvider>
			<LeadProvider>
				<ProjectBudgetProvider>
					<ProjectProvider>
						<BrowserRouter>
							<Switch>
								<Route
									exact
									path="/dashboard"
									component={DashboardPage}
								/>

								<Route
									exact
									path="/accounts/:id"
									render={routeProps => (
										<>
											<ProjectsBudgetTable
												{...routeProps}
											/>
											<ProjectsTable {...routeProps} />
											<AccountProductsTable {...routeProps} />
										</>
									)}
								/>
								<Route
									exact
									path="/leads/upload-csv"
									component={UploadPage}
								/>
								<Route
									exact
									path="/leads/:id"
									render={routeProps => (
										<>
											<LeadPage {...routeProps} />
										</>
									)}
								/>

								<Route
									exact
									path="/accounts/:id/create-project"
									component={CreateProjectPage}
								/>
								<Route
									exact
									path="/accounts/:id/create-project-budget"
									component={CreateProjectBudgetPage}
								/>
								<Route
									exact
									path="/projects/:id/:taskId?"
									component={ProjectDashboardPage}
								/>
								<Route
									exact
									path="/project-budget/:id"
									component={ProjectBudgetPage}
								/>
								<Route
									exact
									path="/my-projects"
									component={MyProjectsListPage}
								/>
								<Route
									exact
									path="/products/libraries"
									component={LibraryPage}
								/>
								<Route
									exact
									path="/products/bundles"
									component={BundlePage}
								/>
								<Route
									exact
									path="/products"
									component={ProductPage}
								/>
								<Route
									exact
									path="/promos"
									component={PromoPage}
								/>
							<Route
								exact
								path="/forms"
								component={FormAdminPage}
							/>
							<Route
								exact
								path="/tags"
								component={TagAdminPage}
							/>
								<Route
									exact
									path="/users"
									component={UsersListPage}
								/>
								<Route
									exact
									path="/reports/pipeline"
									component={PipelineFunnelPage}
								/>
								<Route
									exact
									path="/reports/conversion"
									component={ConversionReportPage}
								/>
								<Route
									exact
									path="/reports/sales-cycle"
									component={SalesCyclePage}
								/>
							</Switch>
						</BrowserRouter>
					</ProjectProvider>
				</ProjectBudgetProvider>
			</LeadProvider>
		</UserProvider>
	);
};

const root = document.getElementById("react-root");

if (root) {
	const rootElement = createRoot(root);
	rootElement.render(<App />);
}
